import { ContentOverviewActionTypes } from '../types/ContentActionTypes';
export const contentOverviewActions = {
    findContentAction: (payload) => ({
        type: ContentOverviewActionTypes.FIND_CONTENT,
        payload,
    }),
    showPlaceholderTiles: () => ({
        type: ContentOverviewActionTypes.SHOW_PLACEHOLDER_TILES,
    }),
    updaterContentAction: (payload) => ({
        type: ContentOverviewActionTypes.UPDATE_CONTENT,
        payload,
    }),
    updaterFiltersAction: (payload) => ({
        type: ContentOverviewActionTypes.UPDATE_FILTERS,
        payload,
    }),
};
